/* eslint-disable react-hooks/exhaustive-deps */
import { Card, Grid, Icon, IconButton } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import MDBox from 'shared/components/MDBox';
import MDTypography from 'shared/components/MDTypography';
import DashboardLayout from 'shared/examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'shared/examples/Navbars/DashboardNavbar';
import DataTableApi from 'shared/components/tables/DatatableApi';

import MDInput from 'shared/components/MDInput';
import { useEffect, useState } from 'react';
import MDButton from 'shared/components/MDButton';
import NotificationItem from 'shared/examples/Items/NotificationItem';
import PatientService from 'shared/services/patients/patients.service';
import PopUp, { dialogButton } from 'shared/components/pop_up';
import { useNavigate } from 'react-router-dom';
import MDProgress from 'shared/components/MDProgress';
import { userLogged } from 'utils/essentialData';
import toastError from 'shared/components/snackbar/error/toastError';
import toastSuccess from 'shared/components/snackbar/success/toastSuccess';

function Patients() {
  const navigate = useNavigate();
  const [openPopUp, setOpenPopUp] = useState(false);
  const [patientStatus, setPatientStatus] = useState();
  const [dataTable, setDataTable] = useState([]);
  const [rowSelected, setRowSelected] = useState();
  const [filter, setFilter] = useState('');
  const [filterSearch, setFilterSearch] = useState('');

  const [userRole, setUserRole] = useState();

  const [loadingData, setLoadingData] = useState(false);
  const [tableLimit, setTableLimit] = useState(10);
  const [tablePage, setTablePage] = useState(1);
  const [tableTotal, setTableTotal] = useState(0);

  const dataTableData = {
    columns: [
      {
        Header: 'nome',
        accessor: 'name',
      },
      {
        Header: 'Responsável',
        accessor: 'mother_name',
        Cell: ({ value }) => value,
      },

      {
        Header: 'Status',
        accessor: 'status',
        Cell: ({ value }) => (value === 0 ? 'Inativo' : 'Ativo'),
      },

      {
        Header: 'ações',
        accessor: 'action',
        width: '15%',
      },
    ],

    rows: dataTable?.data || [],
  };

  const handleCancelStatus = () => setOpenPopUp(false);

  const handleApplyStatus = async () => {
    try {
      let userStatus = rowSelected.original.status;
      if (userStatus === 1) userStatus = 0;
      else userStatus = 1;

      const data = {
        uuid: rowSelected.original.uuid,
        status: userStatus,
      };
      await PatientService.updateStatus(data);
      toastSuccess('Paciente editado com sucesso');
      loadPatients(tablePage, tableLimit, filterSearch);
    } catch (e) {
      if (e.message.includes('<p>')) {
        toastError(<div dangerouslySetInnerHTML={{ __html: e.message }} />);
      } else toastError(e.message);
    } finally {
      setOpenPopUp(false);
    }
  };

  const loadPatients = async (page = 1, limit = 5, filter = '') => {
    try {
      setLoadingData(true);
      const filterValue = filter !== '' ? `&filter=${filter.trim()}` : '';
      const res = await PatientService.list(
        `?page=${page}&limit=${limit}${filterValue}&status=0,1`,
      );
      if (res) {
        setDataTable(res);
        setTableTotal(res?.meta?.total);
      }
    } catch (e) {
      toastError(e.message);
    } finally {
      setLoadingData(false);
    }
  };

  const handleChange = (event) => {
    const { value } = event.target;
    if (value === '') {
      loadPatients(1, tableLimit);
      setTablePage(1);
      setFilterSearch('');
    }
    setFilter(value);
  };

  const handleClickSearch = () => {
    setFilterSearch(filter.trim());
    setTablePage(1);
    loadPatients(1, tableLimit, filter);
  };

  useEffect(
    () => loadPatients(tablePage, tableLimit, filterSearch),
    [tablePage, tableLimit],
  );

  useEffect(() => setUserRole(userLogged()?.role ?? ''), []);

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pb={3}>
          <MDBox mb={3}>
            <MDBox pb={1}>
              <Card>
                <MDBox p={3} lineHeight={1}>
                  <MDTypography variant='h5' fontWeight='medium'>
                    Filtros
                  </MDTypography>
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <MDInput
                        type='text'
                        name='filter'
                        value={filter}
                        size='small'
                        fullWidth
                        InputProps={{
                          endAdornment: (
                            <IconButton
                              sx={{ visibility: filter ? 'visible' : 'hidden' }}
                              size='small'
                              onClick={() =>
                                handleChange({ target: { value: '' } })
                              }
                            >
                              <ClearIcon />
                            </IconButton>
                          ),
                        }}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={2} display='flex'>
                      <MDButton
                        disabled={!filter}
                        variant='gradient'
                        color='primary'
                        size='small'
                        fullWidth
                        onClick={handleClickSearch}
                      >
                        BUSCAR
                      </MDButton>
                    </Grid>
                  </Grid>
                </MDBox>
              </Card>
            </MDBox>
            <Card>
              <MDBox p={3} lineHeight={1}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <MDTypography variant='h5' fontWeight='medium'>
                      Pacientes
                    </MDTypography>
                  </Grid>
                  {userRole === 99 && (
                    <Grid item xs={12} sm={6}>
                      <MDBox width='12rem' ml='auto'>
                        <MDButton
                          variant='gradient'
                          color='primary'
                          size='small'
                          fullWidth
                          onClick={() => navigate('/pacientes/criar')}
                        >
                          CRIAR
                        </MDButton>
                      </MDBox>
                    </Grid>
                  )}
                </Grid>
              </MDBox>

              {loadingData && !dataTable?.data ? (
                <MDProgress
                  variant='gradient'
                  variantProgress='indeterminate'
                  color='primary'
                />
              ) : (
                <DataTableApi
                  table={dataTableData}
                  onRowSelected={setRowSelected}
                  entriesPerPage={{ defaultValue: tableLimit }}
                  setTableLimit={setTableLimit}
                  tableLimit={tableLimit}
                  setTablePage={setTablePage}
                  tablePage={tablePage}
                  tableTotal={tableTotal}
                  loading={loadingData}
                >
                  {[
                    <NotificationItem
                      onClick={() => {
                        const { uuid } = rowSelected.original;
                        navigate(`/pacientes/editar/${uuid}/ver`);
                      }}
                      icon={<Icon>visibility</Icon>}
                      title='Ver'
                      key='option_view'
                    />,
                    <NotificationItem
                      onClick={() => {
                        const { uuid } = rowSelected.original;
                        navigate(`/pacientes/editar/${uuid}/editar`);
                      }}
                      icon={<Icon>create</Icon>}
                      title='Editar'
                      key='option_edit'
                    />,
                    <NotificationItem
                      onClick={() => {
                        const { status } = rowSelected.original;
                        setOpenPopUp(true);
                        setPatientStatus(status);
                      }}
                      icon={<Icon>compare_arrows</Icon>}
                      title='Alterar status'
                      key='option_status'
                    />,
                  ]}
                </DataTableApi>
              )}
            </Card>
          </MDBox>
        </MDBox>
      </DashboardLayout>
      <PopUp
        open={openPopUp}
        onClose={() => setRowSelected()}
        title='Alterar status'
        contentText={
          <MDBox>
            Deseja alterar o status deste paciente para
            <strong> {patientStatus === 1 ? 'Inativo' : 'Ativo'}</strong>?
          </MDBox>
        }
        actions={[
          <MDButton
            color='dark'
            variant='outlined'
            onClick={handleCancelStatus}
            style={dialogButton}
            key='cancel'
          >
            cancelar
          </MDButton>,
          <MDButton
            color='primary'
            onClick={handleApplyStatus}
            style={dialogButton}
            key='confirm'
          >
            confirmar
          </MDButton>,
        ]}
      />
    </>
  );
}

export default Patients;
